/**
 * @author xiaohuangmaoth
 * @desc 参训统计新增 | 编辑
 * @date 2021-06-02
 */
import React from "react";
import { connect } from "dva";
import { framework_tool, component_tool } from "@/tool";
import columns from "./columns";
import { getDetailRecord } from "@/utils/commonUtils";

const { WizContainer, modelUtils } = framework_tool;
const { WizSpin, WizCard, WizForm } = component_tool;

class TrainingStatisticsDetail extends WizContainer {
  // 组件名 必传
  componentName = "TrainingStatisticsDetail";

  // 构造函数
  constructor(props) {
    super(props);
    this.state = {
      detailInfo: {},
    };
    this.detailInfo = getDetailRecord(
      props.history,
      "/trainingStatistics/trainingStatisticsList/trainingStatisticsUpd"
    );
    this.isUpd =
      props.location.pathname ===
      "/trainingStatistics/trainingStatisticsList/trainingStatisticsUpd";
  }

  // 监听属性和状态的变化
   propsAndStateOnChange = {
     detailInfo: this._detailInfo.bind(this),
     add: this._add.bind(this),
     upd: this._upd.bind(this)
   };

   _detailInfo(nextProps, nextState) {
     const { detailInfo } = nextProps;
     if (detailInfo["success"] && detailInfo["data"]) {
       nextState.detailInfo = detailInfo["data"]
       nextState.formKey = new Date().getTime()
       return true;
     }
     return false;
   }

   _add(nextProps, nextState) {
    const { add } = nextProps;
    if (add["success"]) {
      wizNotice.success("新增成功");
      this.jumpPage('replace', '/trainingStatistics/trainingStatisticsList');
      return true;
    } else {
      wizNotice.error(add["msg"] || "操作失败");
      return false;
    }
  }
  
  _upd(nextProps, nextState) {
    const { upd } = nextProps;
    if (upd["success"]) {
      wizNotice.success("编辑成功");
      this.jumpPage('replace', '/trainingStatistics/trainingStatisticsList');
      return true;
    } else {
      wizNotice.error(upd["msg"] || "操作失败");
      return false;
    }
  }

  _componentDidMount() {
     if (this.isUpd) {
       this.doAction({
         path: 'statisticsRule/selectOneById',
         payload: {
           key: 'statisticsRule@detailInfo',
           apiParams: { id: this.detailInfo.id }
         },
       })
     }
  }

  // 提交表单
  handleSubmit = (values) => {
    const interfaceName = this.isUpd ? "upd" : "add";
    this.doAction({
      path: `statisticsRule/${interfaceName}`,
      payload: {
        key: `statisticsRule@${interfaceName}`,
        apiParams: values,
      },
    });
  };

  // 渲染函数
  _render() {
    const { statisticsRuleLoading } = this.props;
    const { detailInfo, formKey } = this.state;
    const formProps = {
      key: formKey,
      ref: "form",
      columns: columns.call(this, detailInfo),
      onSubmit: this.handleSubmit,
      record: null,
      preview: null,
      footer: undefined,
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 17 },
      },
    };

    return (
      <WizCard title={(this.isUpd ? "修改" : "新增") + "参训统计"}>
        <WizSpin spinning={statisticsRuleLoading}>
          <WizForm {...formProps} />
        </WizSpin>
      </WizCard>
    );
  }
}

// 数据源
const mapStateToProps = (state, ownProps) => {
   const { statisticsRule } = state;
   const detailInfo = modelUtils.getModelEntity(statisticsRule, 'statisticsRule@detailInfo');
   const add = modelUtils.getModelEntity(statisticsRule, 'statisticsRule@add');
   const upd = modelUtils.getModelEntity(statisticsRule, 'statisticsRule@upd');
   const load = modelUtils.getLoadingState(state, 'statisticsRule');
   return {
      detailInfo,
      add,
      upd,
      ...load
   };
};

export default connect(mapStateToProps)(TrainingStatisticsDetail);
